import React from "react";
import PropTypes from "prop-types";
import {
  filterLocationsByIndexLetter,
  filterLocationsByKeyword,
} from "./utils/filter";

export const UPDATE_SEARCH = "SearchOffice/UPDATE_SEARCH";
export const FILTER_LOCATIONS = "SearchOffice/FILTER_LOCATIONS";

const reducer = (state, action) => {  
  switch (action.type) {
    case UPDATE_SEARCH:
      return {
        ...state,
        view: {
          ...state.view,
          locations: filterLocationsByKeyword(
            state.api.content.locations,
            action.keyword
          ),
        },
      };
    case FILTER_LOCATIONS:
      return {
        ...state,
        view: {
          ...state.view,
          locations: filterLocationsByIndexLetter(
            state.api.content.locations,
            action.activeFilter
          ),
        },
      };
    default:
      return state;
  }
};

export const StateContext = React.createContext();
export const StateDispatchContext = React.createContext();

export function StateProvider({ children, initialState }) {
  const [state, dispatch] = React.useReducer(reducer, {
    api: initialState,
    view: initialState.content
  });

  return (
    <StateContext.Provider value={state}>
      <StateDispatchContext.Provider value={dispatch}>
        {children}
      </StateDispatchContext.Provider>
    </StateContext.Provider>
  );
}

StateProvider.propTypes = {
  children: PropTypes.node.isRequired,
  initialState: PropTypes.shape({}),
};
